import React, { useState } from "react";
import "./services.css";

const frontend = [
  "Experienced with HTML for creating web page structures.",
  "Proficient in CSS for styling web pages.",
  "Skilled in JavaScript for adding interactivity.",
  "Experienced with Angular for building single-page applications.",
  "Knowledgeable in Bootstrap for responsive design.",
  "Proficient in TypeScript for type-safe JavaScript development.",
];

const backend = [
  "Experienced in Spring Boot for building Java-based web applications.",
  "Proficient in creating RESTful APIs.",
  "Knowledgeable in the MVC (Model-View-Controller) architectural pattern.",
  "Skilled in SQL for database management and queries.",
  "Experienced with JPA (Java Persistence API) for ORM (Object-Relational Mapping).",
  "Experienced in Java for backend development.",
];

const seo = [
  "Conducting Keyword Research to improve search engine rankings.",
  "On-Page Optimization to enhance website visibility.",
  "Building quality backlinks through Link Building.",
  "Creating engaging and SEO-friendly content.",
  "Improving website performance with Technical SEO practices.",
];

const Services = () => {
  const [toggleState, setToggleState] = useState(0);

  const toggleTab = (index) => {
    setToggleState(index);
  };

  return (
    <section className="services section" id="services">
      <h2 className="section__title">Services</h2>
      <span className="section__subtitle">What I can do</span>

      <div className="services__container container grid">
        {/* SEO */}
        <div className="services__content">
          <div>
            <i className="uil uil-search services__icon"></i>
            <h3 className="services__title">
              SEO <br /> Specialist
            </h3>
          </div>

          <span className="services__button" onClick={() => toggleTab(1)}>
            View more
            <i className="uil uil-arrow-right services__button-icon"></i>
          </span>

          {/*Modal seo*/}
          <div
            className={
              toggleState === 1
                ? "services__modal active-modal"
                : "services__modal"
            }
          >
            <div className="services__modal-content">
              <i
                onClick={() => toggleTab(0)}
                className="uil uil-times services__modal-close"
              ></i>

              <h3 className="services__modal-title">SEO services</h3>
              <p className="services__modal-description">
                With over two and a half years of experience working with
                diverse clients, I specialize in everything from keyword
                research to on-page optimization, helping websites succeed in
                search engine rankings.
              </p>

              <ul className="services__modal-services grid">
                {seo.map((services, index) => (
                  <li className="services__modal-service" key={index}>
                    <i className="uil uil-check-circle services__modal-icon"></i>
                    <p className="services__modal-info">{services}</p>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        {/* FRONTEND */}
        <div className="services__content">
          <div>
            <i className="uil uil-arrow services__icon"></i>
            <h3 className="services__title">
              Frontend <br /> developer
            </h3>
          </div>

          <span className="services__button" onClick={() => toggleTab(2)}>
            View more
            <i className="uil uil-arrow-right services__button-icon"></i>
          </span>

          {/*Modal front*/}
          <div
            className={
              toggleState === 2
                ? "services__modal active-modal"
                : "services__modal"
            }
          >
            <div className="services__modal-content">
              <i
                className="uil uil-times services__modal-close"
                onClick={() => toggleTab(0)}
              ></i>

              <h3 className="services__modal-title">Frontend services</h3>
              <p className="services__modal-description">
                I have honed my skills through personal projects and bring half
                a year of professional experience in frontend and backend
                development.
              </p>

              <ul className="services__modal-services grid">
                {frontend.map((services, index) => (
                  <li className="services__modal-service" key={index}>
                    <i className="uil uil-check-circle services__modal-icon"></i>
                    <p className="services__modal-info">{services}</p>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        {/* BACKEND */}
        <div className="services__content">
          <div>
            <i className="uil uil-database services__icon"></i>
            <h3 className="services__title">
              Backend <br /> developer
            </h3>
          </div>
          <span className="services__button" onClick={() => toggleTab(3)}>
            View more
            <i className="uil uil-arrow-right services__button-icon"></i>
          </span>
          {/*Modal back*/}
          <div
            className={
              toggleState === 3
                ? "services__modal active-modal"
                : "services__modal"
            }
          >
            <div className="services__modal-content">
              <i
                className="uil uil-times services__modal-close"
                onClick={() => toggleTab(0)}
              ></i>

              <h3 className="services__modal-title">Backend services</h3>
              <p className="services__modal-description">
                I have honed my skills through personal projects and bring half
                a year of professional experience in frontend and backend
                development.
              </p>

              <ul className="services__modal-services grid">
                {backend.map((serv, index) => (
                  <li className="services__modal-service" key={index}>
                    <i className="uil uil-check-circle services__modal-icon"></i>
                    <p className="services__modal-info">{serv}</p>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
